import { useAuth } from '../contexts/AuthContext';

// useCan("agent", "read") or useCan("agent", "write") -> boolean
// Internal admins always get true.
export const useCan = (componentCode, action) => {
  const { access } = useAuth();
  if (access?.internal_admin) return true;
  const perms = access?.permissions?.[componentCode];
  if (!perms) return false;
  return action === 'write' ? !!perms.can_write : !!perms.can_read;
};

export default useCan;
